import React from 'react'
import axios from 'axios';
import './Assessments.css'
import AnswerPart from './AnswerPart';

const Situation = (props) => {
  return (
    <div className="answer-part-container" key={props.Sequence}>
        <h3>{props.Situation_Heading}</h3>
        <hr/>
        <img src={axios.defaults.baseURL + '/' + props.Situation_Image} className="img-responsive" />
        <div style={{whiteSpace: 'pre-wrap'}}
          dangerouslySetInnerHTML={{
            __html: props.Situation_Description
          }}></div>
        {
            props.AnswerParts.map(answerPart =>
                <AnswerPart {...answerPart} behaviors={props.behaviors} />
              )
        }
    </div>
  )
}

export default Situation